import Axios from 'axios'
import requestPrefix from '../requestPrefix'
import { localDev } from '../../utils/constant'

const prefix = localDev ? '' : requestPrefix.projectUrl

/**
 * 分页查询工地列表
 */
export function page(data) {
  return Axios({
    url: prefix + '/project/page',
    method: 'post',
    data: data
  })
}

export function listIdAndNameByUserId(data) {
  return Axios({
    url: prefix + '/project/selectProjectInfoByUserId',
    method: 'get',
    params: data
  })
}

export function saveDefaultProjectId(id) {
  return Axios({
    url: prefix + '/project/saveDefaultProjectId/' + id,
    method: 'get'
  })
}

/**
 *  查询无锡天气
 *  data extensions all预报 base实时
 */
export function weatherInfo(id) {
  return Axios({
    url: prefix + '/kanban/all/getWuXiAirQuality/' + id,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/project/index.js